import { gql, useQuery } from '@apollo/client';

export const GET_QUESTIONNAIRES_SETTINGS_BY_IDS = gql`
  query getEmployeeQuestionnaireSettingByIds($settingIds: [String!]!) {
    getEmployeeQuestionnaireSettingByIds(settingIds: $settingIds) {
      _id
      name
    }
  }
`;
export const useGetEmployeeQuestionnaireSettingByIds = (settingIds?: string[]) => {
  const { data, loading } = useQuery(GET_QUESTIONNAIRES_SETTINGS_BY_IDS, {
    variables: {
      settingIds,
    },
    skip: !settingIds?.length,
    fetchPolicy: 'cache-and-network',
  });

  return {
    questionnaireSetting: data?.getEmployeeQuestionnaireSettingByIds || [],
    loading,
  };
};
